import React from "../_snowpack/pkg/react.js";
import "./FormTextInput.css";
import cs from "../_snowpack/pkg/classnames.js";
export default function FormTextInput({
  label = "",
  name = "default",
  type = "text",
  className,
  onChange,
  value,
  autocomplete,
  customRef,
  danger,
  ...rest
}) {
  return /* @__PURE__ */ React.createElement("div", {
    className: cs("form-text-input-component", danger && `form-text-input-component--danger`, className)
  }, /* @__PURE__ */ React.createElement("label", {
    htmlFor: name
  }, label), /* @__PURE__ */ React.createElement("input", {
    type,
    name,
    onChange,
    value,
    autoComplete: autocomplete,
    ref: customRef,
    ...rest
  }));
}
